<!-- new Component: 사용 안내문, ASB-12562 분리 from myCouponDTL.vue & giftCoupon.vue -->

<template>
  <div class="voucher_info_box">
    <h2 class="title">
      파이토 카페 음료와 함께<br>
      건강한 웰니스 에너지 충전
    </h2>
    <div class="voucher_info_inner">
      <div class="voucher_info_sub">장소</div>
      <p class="voucher_info_txt">파이토 카페가 있는 전국 ABC/A STATION </p>
      <span>(분당/강서/인천/대전/울산/부산/창원/전주 ABC 및 A STATION)
        <!-- S : 20250325 추가(ASB-12561) -->
                  <br>
                  <br>
                  ※ 파이토 카페가 없는 ABC의 경우, XS 에너지 음료로 대체 사용 가능
                  <br>
                  &nbsp;&nbsp;&nbsp;&nbsp;(대구, 광주, 청주, 강릉, 제주 ABC)
        <!-- E : 20250325 추가(ASB-12561) -->
          </span>
    </div>
    <div class="voucher_info_inner">
      <div class="voucher_info_sub">이용기한</div>
      <p class="voucher_info_txt">{{ makeDateFormat(expDate) }}</p>
    </div>
    <div class="voucher_info_inner">
      <div class="voucher_info_sub">이용안내</div>
      <ul class="voucher_info_list">
        <!-- S : 20221005 수정-->
        <li>바우처 1장당 음료 한잔 (3,500원 가격) 선택이 가능합니다. (베이커리, 스낵 제외)</li>
        <!-- S : 20250325 추가(ASB-12561) -->
        <li>파이토 카페가 없는 ABC의 경우, 바우처 1장당 XS 에너지 음료 한 개로 교환 가능합니다.<br>(XS 그레이프 후르츠, XS 니온, XS 크랜베리, XS ELITE 피치, XS 아쿠아블라스트, XS 푸로틴워터 20)</li>
        <!-- E : 20250325 추가(ASB-12561) -->
        <li>3,500원 이상 음료 선택 시, 추가 금액은 별도 결제 가능합니다. (3,500원 미만 음료는 차액 지불 미적용)</li>
        <li>바우처는 현금으로 교환 및 잔액 환불이 불가합니다.</li>
        <li>음료 선택 후, 파이토 카페 직원에게 바우처를 제시해 주시기 바랍니다.
          <!-- S : 20250325 추가(ASB-12561) -->
          (파이토 카페가 없는 경우, 인포메이션에서 확인 가능합니다.)
          <!-- E : 20250325 추가(ASB-12561) -->
        </li>
        <!-- E : 20221005 수정-->
      </ul>
      <!-- S : 20221005 추가 -->
      <div class="voucher_info_inner">
        <div class="voucher_info_sub">유의사항</div>
        <ul class="voucher_info_list">
          <li>이용기한은 바우처 표기기한까지 입니다.</li>
          <li>이용기한 내 바우처 미사용 시, 분실 시 재발급 불가합니다.</li>
          <li>바우처가 포함된 메시지 삭제 시, 재발송 불가합니다.</li>
          <li>바우처 선물 받으실 분의 휴대폰 번호를 정확히 입력해 주시기 바랍니다. 바우처 발송 후 회수 및 취소 불가합니다.</li>
          <li>양도/양수 가능합니다.</li>
        </ul>
      </div>
      <!-- E : 20221005 추가 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'infotagUse',
  props: {
    expDate: String
  },
  methods: {
    makeDateFormat: function (tDate) {
      if (tDate) {
        const dt = new Date(tDate)
        return dt.getFullYear() + '년 ' + (dt.getMonth() + 1) + '월 ' + dt.getDate() + '일 까지'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/concierge/component/infotagUse.vue